'use client'

import type { ComponentProps } from 'react'

import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'
import {
  ConversationMessageType,
  ConversationMessage,
  Message as MessageType,
} from '@marketplace-web/messaging/conversation-messaging-data'

import Message from '../../Message'
import PhotoMessages from './components/PhotoMessages'

type Props = ConversationMessage & {
  message: MessageType
  isGrouped: boolean
  isLast: boolean
  isCurrentAuthor: boolean
} & Pick<ComponentProps<typeof PhotoMessages>, 'onThumbnailClick'>

const UserMessage = ({
  message,
  isGrouped,
  isLast,
  isCurrentAuthor,
  entityType,
  createdTime,
  onThumbnailClick,
}: Props) => {
  const { conversation } = useConversationContext()
  const isReadByOppositeUser = conversation?.isReadByOppositeUser ?? false

  const isMessageBubbleVisible = message.content || message.isHidden

  return (
    <>
      {isMessageBubbleVisible && (
        <Message
          createdTime={createdTime}
          isCurrentAuthor={isCurrentAuthor}
          isGrouped={isGrouped}
          isLast={isLast}
          isLastAndRead={isLast && isReadByOppositeUser}
          isPortalMessage={entityType === ConversationMessageType.PortalMessage}
          message={message}
        />
      )}
      <PhotoMessages
        createdTime={createdTime}
        isCurrentAuthor={isCurrentAuthor}
        isLast={isLast}
        message={message}
        isReadByOppositeUser={isReadByOppositeUser}
        onThumbnailClick={onThumbnailClick}
      />
    </>
  )
}

export default UserMessage
